import { useMemo } from 'react';
import { BOOKKEEPER_ACCOUNT_TYPES } from '../constants';
import { useGetBookkeepersQuery } from '../api/bookkeepersApi';

/**
 * @description Hook for getting the options used when mentioning a bookkeeper in a message
 */
export const useBookkeeperMentionOptions = () => {
  const { data: bookkeepers = [], isLoading: areBookkeepersLoading } = useGetBookkeepersQuery();

  /** Bookkeeper options for tag autocompletion */
  const bookkeeperOptions = useMemo(() => {
    if (areBookkeepersLoading) {
      return [];
    }
    const taxExperts = bookkeepers
      .filter((bookkeeper) => bookkeeper.accountType === BOOKKEEPER_ACCOUNT_TYPES.TAX_EXPERT)
      .map((bookkeeper) => {
        const duplicateBookkeeperExists =
          bookkeepers.filter((b) => b.firstname === bookkeeper.firstname && b.lastname === bookkeeper.lastname).length >
          1;
        return {
          label: duplicateBookkeeperExists
            ? `${bookkeeper.firstname} ${bookkeeper.lastname} (${bookkeeper.email})`
            : `${bookkeeper.firstname} ${bookkeeper.lastname}`,
          value: bookkeeper.id
        };
      });
    return taxExperts;
  }, [bookkeepers, areBookkeepersLoading]);

  return { data: bookkeeperOptions, isLoading: areBookkeepersLoading };
};
